import styled from 'styled-components'

export const FeaturedResourceContainer = styled.div<{
  $resourceTheme: string
  $useCase: string
  $pageType: string
}>`
  ${({ theme, $resourceTheme, $useCase, $pageType }) => {
    const eyebrow =
      $resourceTheme === 'dark'
        ? theme.webMktNewPalette.deepBlue[55]
        : theme.webMktNewPalette.deepBlue[55]
    const dottedColor =
      $resourceTheme === 'dark'
        ? theme.webMktNewPalette.alphaWhite[70]
        : theme.webMktNewPalette.alphaBlack[50]
    const body =
      $resourceTheme === 'dark' ? theme.webMktNewPalette.white : theme.webMktNewPalette.black
    const background =
      $resourceTheme === 'dark' ? theme.webMktNewPalette.deepBlue[70] : theme.webMktNewPalette.white
    const FWTEXTbackground = $resourceTheme === 'dark' ? '' : theme.webMktNewPalette.deepBlue[5]
    const CTA_background =
      $resourceTheme === 'dark' ? theme.webMktNewPalette.black : theme.webMktNewPalette.orange[50]
    const CTA_hover =
      $resourceTheme === 'dark' ? theme.webMktNewPalette.black : theme.webMktNewPalette.black
    let useCaseStyles = ''
    if ($useCase === 'full width') {
      useCaseStyles = ` 
      background: ${background};     
      .usecaselayout{
        color: #cc0000;
        max-width: ${$pageType === 'aboutRPA' ? '1374px' : '100%'};
        margin: ${$pageType === 'aboutRPA' ? '0 auto 0 0' : '0 auto'};
        .FeaturedResource__Inner{
          max-width: ${$pageType === 'aboutRPA' ? 'none' : '1374px'};
        }
        .FeaturedResource__Inner-Text{
          ${theme.breakpoints.down('xs')} {
           display:flex;
           flex-direction:column;
           order:1;
            }
        }
        .FeaturedResource__Image-Graphic-Outer{
          ${theme.breakpoints.down('xs')} {
          width:auto;
          display:flex;
          order:0;
        }
        :before {
          display: none;
        }
      }
      .FeaturedResource__Eyebrow {
       
      }
      .FeaturedResource__CTA-Container span {
        display: none;
      }
      .FeaturedResource__Inner-Body__RichText {
        display: block;

      }
      .FeaturedResource__CTA-Container .Video__CTA{
        padding: 0;
        height: 56px;
      }
      .FeaturedResource__CTA-Container .CTA__Arrow-Container {
        display: inline;
        padding: 15px;
        margin-left: 0px;
      }
      .FeaturedResource__Inner .FeaturedResource__Inner-Text {
        padding: 24px;
        background: ${FWTEXTbackground};
        width:444px;
        ${theme.breakpoints.down('lg')} {
          width:100%
        }
        box-sizing:border-box;
        position:relative;
      }
      .FeaturedResource__CTA-Container{
        position:absolute;
        bottom:0;
        ${theme.breakpoints.down('sm')} {
         position:relative;
        }        
      }
     
      .FeaturedResource__Inner-Heading {
        
      }
      .FeaturedResource__Image-Container {
        .FeaturedAsset__Video {
          .VideoPlayer__Image-File {
            height: 360px;
            width: 100%;
            object-fit: cover;
            ${theme.breakpoints.down('xs')} {
              height: auto;
            }
          }
        }

        ${theme.breakpoints.down('md')} {
          width: 100%;
          padding: 0px;
          box-sizing: border-box;
        }
        ${theme.breakpoints.down('sm')} {
          width: 100%;
          padding: 24px;
          box-sizing: border-box;
        }
      }
      .FeaturedResource__Image {
        width: 100%;
        ${theme.breakpoints.down('md')} {
          width: 100%;
        }
        ${theme.breakpoints.down('sm')} {
          width: 46%;
        }
        margin-top:0
      }
      .FeaturedResource__CTA-1 {
        padding: 0px;
      }
      
      .FeaturedResource__CTA-2 {
        display: none;
      }
      .FeaturedResource__CTA-1.CTA :hover svg #ArrowPath {
        fill: ${theme.webMktNewPalette.white};
      }     
      .CTA__Arrow-Container svg Path {
        fill: ${theme.webMktNewPalette.white};
      }
      .FeaturedResource__Image-Container .CTA__Arrow-Container {
        display: none;
      }    
          
      .FeaturedResource__Image-Container{
        width:auto;
      }
      `
    } else if ($useCase === 'square') {
      useCaseStyles = `
      .usecaselayout{
        max-width:1220px;
        margin: ${$pageType === 'aboutRPA' ? '0 auto 0 0' : '0 auto'};
        padding: 0px;
       .FeaturedResource__Inner-Text{
        padding-left:24px;
        padding-right: 24px;       
        box-sizing:border-box;
        padding-top:0;
        ${theme.breakpoints.down('lg')} {
          max-width:100%;
          padding-left: 48px;
        }
        ${theme.breakpoints.down('md')} {
          padding-left: 48px;
        }
        ${theme.breakpoints.down('sm')} {
          padding-left: 72px;
        }
        ${theme.breakpoints.down('xs')} {
          padding-left: 24px;
        }
       }
      }
     
      .FeaturedResource__Image-Graphic-Outer:before {       
        background-image: radial-gradient(${dottedColor} 1px, transparent 0);        
      }
      .FeaturedResource__Eyebrow {
       
      }
      .FeaturedResource__Lower-Icon-Container {
        left: 122px;
      }
      .FeaturedResource__Inner .FeaturedResource__Image-Graphic-Outer {
        width: 442px;
        
        ${theme.breakpoints.down('md')} {
         width:300px;
         margin-left:0;
        }
        ${theme.breakpoints.down('sm')} {
         margin: 0 auto 0 48px;
        }
        ${theme.breakpoints.down('xs')} {
          margin-right: 0;
         }
      }
      .FeaturedResource__Inner .FeaturedResource__Image-Graphic-Outer:before {
        background-size: 24px 24px;
        width:435px;
      
        ${theme.breakpoints.down('lg')} {
          width:325px;
          left:-10px
        }
        ${theme.breakpoints.down('md')} {
          background-size: 21px 21px;
          left: -10px;
          width: 255px;
        }
        ${theme.breakpoints.down('sm')} {
          background-size: 21px 21px;
          left: -27px;
          width: 260px;
        }  
        ${theme.breakpoints.down('xs')} {
         
          width: 300px;
        }      
      }
      .FeaturedResource__Image-Container  {
        .FeaturedAsset__Video {
          .VideoPlayer__Image-File{
            width: 282px;
            height: 282px;
            object-fit: cover;
            ${theme.breakpoints.down('lg')} {
              width: 250px;
              height: 250px;
            }
            ${theme.breakpoints.down('md')} {
              width: 172px;
              height: 172px;
              min-height: 148px;
            }
            ${theme.breakpoints.down('sm')} {
              width: 196px;
              height: 204px;
              min-height: auto;
            }  
            ${theme.breakpoints.down('xs')} {             
              width: 240px;
              height: 240px;
            } 
          }
        }

        FeaturedAsset__Image {
          position: relative;
        }
        .FeaturedResource__arrow-link {
          position: absolute;
          z-index: 1;
          bottom: 0;
          a {
            width: 56px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;

            .CTA__Arrow-Container{
              background: none;
              left: 0;
              position: relative;
            }
          }
        }
      }
      .FeaturedResource__Image-Container .CTA__Arrow-Container {
        position: absolute;
        bottom: 0;
        left: calc(50% - 282px/2);
        ${theme.breakpoints.down('lg')} {
          left: calc(100%/2 - 230px/2);
        }
        ${theme.breakpoints.down('md')} {
          left: calc(100%/2 - 172px/2);
        }
        ${theme.breakpoints.down('sm')} {
          left: calc(50% - 120px);
        }
      }
      .FeaturedResource__Image-Container .CTA__Arrow-Container {
        display: inline;
        background: ${CTA_background};
        padding: 12px;
        margin-left: 0px;
      }
      
     }
      .FeaturedResource__Image-Container{
        width:441px;
        ${theme.breakpoints.down('lg')} {
          width:370px;
        }
      }
      .FeaturedResource__Image{
        ${theme.breakpoints.down('lg')} {
          margin-top:10px
        }
      }
      `
    } else {
      useCaseStyles = `
      .FeaturedResource__Image-Graphic-Outer:before {
        background-image: radial-gradient(${dottedColor} 1px, transparent 0);
        width:378px;
      }
      .FeaturedResource__Lower-Icon-Container {
        position: absolute;
        right: 0px;
      }
      
      .FeaturedResource__Image-Container .CTA__Arrow-Container {
        display: none;
      }
      .CTA__Arrow-Container {
        width: 25px;
        height: 25px;
      }
      .CTA__Arrow-Container svg {
        width: 25px;
        height: 25px;
      }
      .FeaturedResource__Image-Container{
        width:auto;
      }
        .FeaturedResource__arrow-link{
          display: none;
        }
      `
    }

    return `
    &.fullwidth {        
      .FeaturedResource__arrow-link{
        display: none;
      }
    }
     ${useCaseStyles}
      background: ${background};
      padding: 96px 0 96px 0;

      ${theme.breakpoints.down('md')} {
        padding: 64px 0 64px 0;
      }

      .FeaturedResource__Eyebrow {
        color: ${eyebrow};
        margin-bottom: 12px;

        ${theme.breakpoints.down('md')} {
          margin-bottom: 8px;
        }
      }

      .FeaturedResource__Pill {
        position: absolute;
        top: 0;
        background: ${theme.webMktNewPalette.background.light.default};
        left: 0;
        margin: 0;
        padding: 4px 8px;
        color: ${theme.webMktNewPalette.deepBlue[55]};
      }

      .FeaturedResource__Inner-Heading {
        color: ${body};
      }

      .FeaturedResource__Image-Graphic-Outer:before {
        background-image: radial-gradient(${dottedColor} 1px, transparent 0);
      }

      .FeaturedResource__Inner-Body{
        margin: 24px 0 0 0;

        p, li {
          color: ${body};
        }
        
        p {
          margin: 24px 0;
        }

        ul {
          list-style-type: disc;
          padding-left: 24px;
        }

        li {
          p {
            margin: 0;
          }

          a {
            margin: 0 0 0 12px;
            display: inline;
          }

          margin-bottom: 8px;
        }

        a {
          color: ${
            $resourceTheme === 'dark'
              ? theme.webMktPalette.text.actionDark
              : theme.webMktNewPalette.action.light.primary
          };

          &:hover {
            text-decoration: underline;
          }
        }

        .richText-styled-list {
          .richText-styled-list-items {
            p {
              a {
                margin: 0;
              }
            }
          }
        }
      }

      .FeaturedResource__Inner-Body__RichText {
        p, li {
          color: ${body};
        }

        .richText-styled-list, .richText-styled-list > * {
          color: ${body};
        }
      }
    `
  }}

  .FeaturedResource__Image {
    width: ${({ $useCase }) => {
      switch ($useCase) {
        case 'square':
          return '282px'
        case 'full width':
          return '100%'
        default:
          return '384px'
      }
    }};
    height: ${({ $useCase }) => {
      switch ($useCase) {
        case 'square':
          return '282px'
        case 'full width':
          return '360px'
        default:
          return '218px'
      }
    }};
    object-fit: cover;

    ${({ theme }) => theme.breakpoints.down('lg')} {
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '250px'
          default:
            return ''
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '250px'
          default:
            return ''
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '100%'
          case 'square':
            return '172px'
          default:
            return '222px'
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '360px'
          case 'square':
            return '172px'
          default:
            return 'auto'
        }
      }};
      min-height: 148px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '100%'
          case 'square':
            return '172px'
          default:
            return '172px'
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '360px'
          case 'square':
            return '172px'
          default:
            return '97px'
        }
      }};
      min-height: auto;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '100%'
          default:
            return '240px'
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return 'auto'
          case 'square':
            return '240px'
          default:
            return '135px'
        }
      }};
    }
  }

  .FeaturedResource__Inner-Heading {
    margin-bottom: 24px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin-bottom: 0;
    }
  }

  .FeaturedResource__CTA-1 {
    margin-right: 32px;
    height: 54px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      justify-content: space-between;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin-right: 0;
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return 'auto'
          case 'square':
            return '100%'
          default:
            return '100%'
        }
      }};
    }
  }

  .FeaturedResource__CTA-Container {
    margin-top: ${({ $useCase }) => {
      switch ($useCase) {
        case 'full width':
          return '70px'
        default:
          return '32px'
      }
    }};
    margin-bottom: ${({ $useCase }) => {
      switch ($useCase) {
        case 'full width':
          return '24px'
      }
    }};
    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin-top: 32px;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      max-width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '330px'
        }
      }};
    }
  }

  .FeaturedResource__Inner {
    display: flex;
    flex-direction: row;
    justify-content: ${({ $useCase }) => {
      switch ($useCase) {
        case 'full width':
          return 'flex-start'
        case 'square':
          return 'flex-start'
        default:
          return 'space-between'
      }
    }};
    align-items: center;
    margin: 0 auto;
    gap: ${({ $useCase }) => {
      switch ($useCase) {
        case 'full width':
          return 'initial'
        case 'square':
          return 'initial'
        default:
          return '16px'
      }
    }};

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column;
      width: 100%;
    }

    .FeaturedResource__Image-Graphic-Outer {
      height: auto;
      position: relative;
      align-self: flex-start;
      max-width: 930px;

      ${({ theme }) => theme.breakpoints.down('lg')} {
        margin-left: ${({ $useCase }) => {
          switch ($useCase) {
            case 'full width':
              return '0'
            case 'square':
              return '0px'
            default:
              return ''
          }
        }};
      }

      ${({ theme }) => theme.breakpoints.down('md')} {
        height: ${({ $useCase }) => {
          switch ($useCase) {
            case 'full width':
              return '360px'
            case 'square':
              return '204px'
            default:
              return '270px'
          }
        }};
        width: ${({ $useCase }) => {
          switch ($useCase) {
            case 'square':
              return '300px'
            case 'full width':
              return '100%'
            default:
              return ''
          }
        }};
        margin-left: ${({ $useCase }) => {
          switch ($useCase) {
            case 'full width':
              return '0px'
            case 'square':
              return '0px'
            default:
              return '82px'
          }
        }};
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: ${({ $useCase }) => {
          switch ($useCase) {
            case 'square':
              return '300px'
            default:
              return ''
          }
        }};
        height: ${({ $useCase }) => {
          switch ($useCase) {
            case 'full width':
              return '360px'
            case 'square':
              return '204px'
            default:
              return '204px'
          }
        }};
        margin-left: ${({ $useCase }) => {
          switch ($useCase) {
            case 'full width':
              return '0px'
            case 'square':
              return '48px'
            default:
              return '48px'
          }
        }};
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        margin-left: 0;
        height: auto;
        margin-bottom: ${({ $useCase }) => {
          switch ($useCase) {
            case 'square':
              return '24px'
            default:
              return '48px'
          }
        }};
        padding: ${({ $useCase }) => {
          switch ($useCase) {
            case 'full width':
              return '0 24px'
            default:
              return ''
          }
        }};
        align-self: center;
        width: auto;
      }

      &:before {
        content: '';
        position: absolute;
        width: ${({ $useCase }) => {
          switch ($useCase) {
            case 'square':
              return '442px'
            default:
              return '378px'
          }
        }};
        height: 189px;
        z-index: 0;
        top: 0;
        left: ${({ $useCase }) => {
          switch ($useCase) {
            case 'square':
              return '0px'
            default:
              return '48px'
          }
        }};
        background-size: 24px 24px;
        ${({ theme }) => theme.breakpoints.down('lg')} {
          width: ${({ $useCase }) => {
            switch ($useCase) {
              case 'square':
                return '320px'
              default:
                return '378px'
            }
          }};
        }

        ${({ theme }) => theme.breakpoints.down('md')} {
          height: ${({ $useCase }) => {
            switch ($useCase) {
              case 'square':
                return '150px'
              default:
                return '141px'
            }
          }};
          width: ${({ $useCase }) => {
            switch ($useCase) {
              case 'square':
                return '240px'
              default:
                return '218px'
            }
          }};
        }

        ${({ theme }) => theme.breakpoints.down('sm')} {
          height: 118px;
          background-size: ${({ $useCase }) => {
            switch ($useCase) {
              case 'square':
                return '21px 21px'
              default:
                return ''
            }
          }};
          width: ${({ $useCase }) => {
            switch ($useCase) {
              case 'square':
                return '260px'
              default:
                return '236px'
            }
          }};
          left: ${({ $useCase }) => {
            switch ($useCase) {
              case 'full width':
                return '0'
              default:
                return '-32px'
            }
          }};
        }

        ${({ theme }) => theme.breakpoints.down('xs')} {
          display: ${({ $useCase }) => {
            switch ($useCase) {
              case 'full width':
                return 'none'
              default:
                return ''
            }
          }};
          height: 152px;
          width: 328px;
          left: -44px;
        }
      }
    }
  }

  .FeaturedResource__Image-Container {
    height: auto;
    width: auto;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: ${({ $useCase }) => {
      switch ($useCase) {
        case 'full width':
          return '0px'
        default:
          return '48px'
      }
    }};
    padding-left: ${({ $useCase }) => {
      switch ($useCase) {
        case 'square':
          return '0px'
        default:
          return ''
      }
    }};
    position: relative;

    ${({ theme }) => theme.breakpoints.down('lg')} {
      align-items: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return 'flex-start'
          default:
            return ''
        }
      }};
      margin-left: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '30px'
          case 'full width':
            return '0px'
          default:
            return ''
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '100%'
          case 'square':
            return '172px'
          default:
            return '222px'
        }
      }};
      margin-left: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '34px'
          default:
            return ''
        }
      }};
      margin-top: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '0px'
          case 'square':
            return '32px'
          default:
            return '32px'
        }
      }};
      padding-left: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
          case 'full width':
            return '0px'
          default:
            return '0px'
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 100%;
      padding: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '0'
          default:
            return ''
        }
      }};
      margin-left: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '0'
          default:
            return ''
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '100%'
          default:
            return ''
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '100%'
          default:
            return '240px'
        }
      }};

      padding-left: ${({ $useCase }) => {
        switch ($useCase) {
          default:
            return '0'
        }
      }};
    }

    .FeaturedResource__Lower-Icon {
      z-index: 2;
      width: auto;
      height: 100%;
      object-fit: contain;
    }

    .Image-Position {
      position: relative;
    }
  }

  .FeaturedResource__Partner-Logo-Container {
    position: absolute;
    z-index: 1;
    background: ${({ theme }) => theme.webMktNewPalette.action.light.primary} / 20%;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 81px 21px;
    box-sizing: border-box;

    ${({ theme }) => theme.breakpoints.down('lg')} {
      padding: 63px 16px;
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      padding: 47px 8px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      padding: 70px 20px;
    }

    .FeaturedResource__Partner-Logo {
      width: auto;
      object-fit: contain;
    }
  }

  .FeaturedResource__Lower-Icon-Container {
    position: absolute;
    width: 56px;
    height: 56px;
    background: ${({ theme }) => theme.webMktNewPalette.button.light.primary};
    z-index: 2;
    bottom: 0;
    right: 0;
    display: ${({ $useCase }) => {
      switch ($useCase) {
        case 'square':
        case 'full width':
          return 'none'
        default:
          return 'flex'
      }
    }};
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.down('md')} {
      width: 48px;
      height: 48px;
    }

    .FeaturedResource__Lower-Icon {
      width: 40px;
      height: 40px;
    }
  }

  .FeaturedResource__Inner-Text {
    max-width: ${({ $useCase }) => {
      switch ($useCase) {
        case 'full width':
          return '444px'
        case 'square':
          return 'calc(100% - 435px)'
        default:
          return '691px'
      }
    }};
    height: ${({ $useCase }) => {
      switch ($useCase) {
        case 'square':
          return 'auto'
        case 'full width':
          return '360px'
        default:
          return 'auto'
      }
    }};
    width: 100%;
    padding-top: 24px;
    ${({ theme }) => theme.breakpoints.down('md')} {
      max-width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return ''
          case 'square':
            return ''
          default:
            return '691px'
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return ''
          case 'square':
            return ''
          default:
            return 'auto'
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      max-width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '100%'
          case 'full width':
            return '454px'
          default:
            return '550px'
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'square':
            return '100%'
          case 'full width':
            return '454px'
          default:
            return '454px'
        }
      }};
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return '100%'
          case 'square':
            return '100%'
          default:
            return '328px'
        }
      }};
      height: ${({ $useCase }) => {
        switch ($useCase) {
          case 'full width':
            return 'auto'
          default:
            return 'auto'
        }
      }};
      margin-left: 0;
      margin-right: 0;
    }
  }
`
